import React from "react";
import downloadIcon from "../assets/images/ota-updates-icon-download.svg";

export const DownloadButton = () => {
    
  return (
    <button className="btn">
      <img src={downloadIcon} alt="Download" />
    </button>
  );
};
